import Tdg_FeedbackListModelBase from '../_generated/modelBases/tdg-feedback-list-model-base';

export default class Tdg_FeedbackListModel extends Tdg_FeedbackListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
